import { Helmet } from 'react-helmet-async'
import { useWhiteLabel } from '../../hooks/useWhiteLabel'

export default function AppHeaders() {
  const { whitelabel } = useWhiteLabel()

  return (
    <>
      <Helmet titleTemplate={`%s | ${whitelabel.name || ''}`} />

      <Helmet>
        {/* <!-- Main Link Tags  --> */}
        <link href={whitelabel.logo?.favicon} rel="icon" type="image/png" />

        {/* <!-- iOS  --> */}
        <link href={whitelabel.logo?.app} rel="apple-touch-icon" />
        <link rel="apple-touch-startup-image" href={whitelabel.logo?.app} />

        {/* <!-- Startup Image  --> */}
        <link href={whitelabel.logo?.app} rel="apple-touch-startup-image" />

        {/* <!-- Pinned Sites  --> */}
        <meta name="application-name" content={whitelabel.name} />

        {/* <!-- Android  --> */}
        <meta name="theme-color" content={whitelabel.theme?.palette?.primary?.main || '#3E75C3'} />
        <meta name="mobile-web-app-capable" content="yes" />

        {/* <!-- iOS --> */}
        <meta name="apple-mobile-web-app-title" content={whitelabel.name} />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      </Helmet>
    </>
  )
}
